import React from 'react';
import { PropTypes } from 'prop-types';
import * as Yup from 'yup';

import SelectDay from '@molecules/SelectDay';
import SelectMonth from '@molecules/SelectMonth';
import SelectYear from '@molecules/SelectYear';

export const editProfileBirthdateValidationSchema = {
    birthdateYear: Yup.string().when(['birthdateMonth', 'birthdateDay'], {
        is: (birthdateMonth, birthdateDay) =>
            (birthdateMonth && birthdateMonth.length) || (birthdateDay && birthdateDay.length),
        then: Yup.string().required('Year is required for birthdate'),
        otherwise: Yup.string(),
    }),
};

const EditProfileFieldsBirthdate = ({ hasBirthdate }) => (
    <>
        <SelectMonth isDisabled={hasBirthdate} name="birthdateMonth" label="Month" />
        <SelectDay isDisabled={hasBirthdate} name="birthdateDay" label="Day" />
        <SelectYear isDisabled={hasBirthdate} name="birthdateYear" label="Year" />
    </>
);

EditProfileFieldsBirthdate.propTypes = {
    hasBirthdate: PropTypes.bool,
};

export default EditProfileFieldsBirthdate;
